import styled from '@emotion/styled'
import { breakpoint, calcRem, metrics } from '../../__styling'

export const StyledLabel = styled('label')<{ size?: number; width?: string }>(
    ({ size = metrics.thenightly.margins.md, width }) => ({
        width: width ?? undefined,

        display: 'flex',
        '& + &': {
            marginLeft: 0,
            marginTop: calcRem(metrics.thenightly.margins.md),
        },

        input: {
            marginRight: calcRem(metrics.thenightly.margins.sm),
            marginLeft: calcRem(metrics.thenightly.margins.sm),

            height: calcRem(size),
            width: calcRem(size),
        },
    }),
)

export const Test = styled('div')<{ size?: number }>(
    ({ size = metrics.thenightly.margins.md }) => ({
        width: '100%',
    }),
)
